export const DESIGNS_GET_REQUEST = "@designs.get.request";
export const DESIGNS_GET_SUCCESS = "@designs.get.success";
export const DESIGNS_GET_FAIL = "@designs.get.failure";

export const DESIGN_LOAD_REQUEST = "@design.load.request";
export const DESIGN_LOAD_SUCCESS = "@design.load.success";
export const DESIGN_LOAD_FAIL = "@design.load.failure";

export const DESIGN_CREATE_REQUEST = "@design.create.request";
export const DESIGN_CREATE_SUCCESS = "@design.create.success";
export const DESIGN_CREATE_FAIL = "@design.create.failure";
export const DESIGN_CREATE_DONE = "@design.create.done";

export const DESIGN_UPDATE_REQUEST = "@design.update.request";
export const DESIGN_UPDATE_SUCCESS = "@design.update.success";
export const DESIGN_UPDATE_FAIL = "@design.update.failure";
export const DESIGN_UPDATE_DONE = "@design.update.done";

export const DESIGN_REQUEST_STEP_COMMIT = "@design.request.step.commit";
export const DESIGN_REQUEST_RESET = "@design.request.reset";

export const DESIGN_EXAMPLES_GET_REQUEST = "@designExamples.get.request";
export const DESIGN_EXAMPLES_GET_SUCCESS = "@designExamples.get.success";
export const DESIGN_EXAMPLES_GET_FAIL = "@designExamples.get.failure";

export const DESIGN_EXAMPLE_LOAD_REQUEST = "@designExample.load.request";
export const DESIGN_EXAMPLE_LOAD_SUCCESS = "@designExample.load.success";
export const DESIGN_EXAMPLE_LOAD_FAIL = "@designExample.load.failure";

export const DESIGN_EXAMPLE_CREATE_REQUEST = "@designExample.create.request";
export const DESIGN_EXAMPLE_CREATE_SUCCESS = "@designExample.create.success";
export const DESIGN_EXAMPLE_CREATE_FAIL = "@designExample.create.failure";
export const DESIGN_EXAMPLE_CREATE_DONE = "@designExample.create.done";

export const DESIGN_EXAMPLE_UPDATE_REQUEST = "@designExample.update.request";
export const DESIGN_EXAMPLE_UPDATE_SUCCESS = "@designExample.update.success";
export const DESIGN_EXAMPLE_UPDATE_FAIL = "@designExample.update.failure";
export const DESIGN_EXAMPLE_UPDATE_DONE = "@designExample.update.done";
